var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const getBPUserInfo = () => __awaiter(void 0, void 0, void 0, function* () {
    const authUrl = new URL(window.RG_CONFIG.AUTH_URL);
    authUrl.pathname = '/v2/userinfo';
    return yield fetch(authUrl.href, {
        method: 'GET',
        credentials: 'include',
    });
});
export default getBPUserInfo;
